import { useState } from 'react';
import { Pagination } from '@/shared/components';
import { useConfigOptionsQuery } from '../hooks/useConfigOptionsQuery';
import { ConfigOptionDataTable } from '../components/ConfigOptionDataTable';

export function ConfigOptionList() {
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(20);

    const query = useConfigOptionsQuery({ page, per_page: perPage });
    const options = query.data?.data ?? [];
    const meta = query.data?.meta;

    return (
        <section className="space-y-4">
            <h1 className="text-2xl font-semibold">Config Options</h1>

            <div className="space-y-4">
                <ConfigOptionDataTable data={options} isLoading={query.isLoading} />

                {meta && meta.last_page > 1 && (
                    <Pagination
                        currentPage={meta.current_page}
                        lastPage={meta.last_page}
                        total={meta.total}
                        perPage={meta.per_page}
                        from={meta.from}
                        to={meta.to}
                        onPageChange={setPage}
                        onPerPageChange={(n) => { setPerPage(n); setPage(1); }}
                    />
                )}
            </div>
        </section>
    );
}
